// Copyright (c) Docugami, Inc. All rights reserved.**/

import { appContentColor } from "components/shell/presentation/AppStyles";
import { ModalCommandItem } from "hooks/ModalCommandItem";
import { dgIconNames } from "hooks/dgIcons";
import { useMemo, useState } from "react";


export interface ExpandedRichTextCommandProps {
    label?: string;
    richText?: string;
}

export interface ExpandedRichTextCommand extends ModalCommandItem {
    label?: string;
    richText?: string;
}

export const useExpandedRichTextCommand = (props: ExpandedRichTextCommandProps): ExpandedRichTextCommand => {
    const [isModalVisible, setIsModalVisible] = useState(false);

    return useMemo(() =>({
        name: `Expand`,
        onClick: () => setIsModalVisible(true),
        onDismiss: () => setIsModalVisible(false),
        isModalVisible: isModalVisible,
        disabled: isModalVisible,
        isVisible: !!props.richText,
        iconDescriptor: {
            name: dgIconNames.ExpandCard,
            height: 1,
            width: 1.39,
            defaultColor: appContentColor
        },
        richText: props.richText,
        label: props.label
    }), [props.richText, props.label, isModalVisible]);
};
